module.exports = __webpack_public_path__ + "media/images/nano-preview-54834a1024033f67e5d456734b96854c.mp4";